module.exports = __webpack_public_path__ + "img/xz.7eaee942.png";